import styled from 'styled-components';

export const StyledNationalIdentificationNumberField = styled.div`
   width: 278px;
`;
StyledNationalIdentificationNumberField.displayName = 'StyledNationalIdentificationNumberField';
